import type {FallbackLegacyEmitter} from "@/store/plugins/emitter";
import type {InjectionKey} from "vue";

export const RootKey: InjectionKey<FallbackLegacyEmitter> = Symbol("rootData");
export const CspNonceKey: InjectionKey<string | null> = Symbol("gspNonce");
